/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var ToggleContent = {
    init: function() {
      this.addEventHandler();
    },
    addEventHandler: function() {
      $('.toggle').click(function(e){
          e.preventDefault();
          $entry = $(this).parent().find('.entry-content');

          if($(this).hasClass('toggle-close')) {
            $entry.slideUp();
            $(this).text('Läs mer').removeClass('toggle-close');
          } else {
            $entry.slideDown();
            $(this).text('Stäng').addClass('toggle-close');
          }
      });
    }
  };


  $('.share a').each(function (i, element) {

    var shareUrl = $('[rel="canonical"]').attr('href');
    
    if (shareUrl) {
      if ($(element).hasClass('share__link--facebook')) {
        $(element).attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + shareUrl);
      }

      if ($(element).hasClass('share__link--twitter')) {
        $(element).attr('href', 'https://twitter.com/share?url=' + shareUrl);
      }

      if ($(element).hasClass('share__link--email')) {
        $(element).attr('href', 'mailto:?subject=' + shareUrl);
      }
    }

  });

  $('.filter-alt a').on( 'click', function( e ) {
    e.preventDefault();

    var content = $(".content .main .archive-publikationer");
    var category = [];

    $(this).toggleClass('selected');

    $('.selected').each(function() {
        category.push($(this).html());
    });

    $.ajax({
      url: ajaxtaxonomy.ajaxtaxurl,
      type: 'POST',
      data: {
        action: 'ajax_taxonomy',
        category: category,
      },
      success: function( data ) {
        content.empty();
        content.append(data);
        ToggleContent.init();
      }
    });
  });

  var MobileNav = {
    init: function() {
      this.addEventHandler();
    },
    addEventHandler: function() {
      $('.dropdown-toggle').on('click', function() {
        $(this).next('.sub-menu').toggleClass('open');
      });
    }
  };

  var NavHover = {
    init: function(container) {
      this.addEventHandler(container);
    },
    mobile: function(container) {
        $(container + ' a').on('mouseenter', function(){
          $selector = $(container + ' li:not(.current-menu-ancestor, .menu-item-has-children.active) a');
          $selector.stop().fadeTo(300,0.5);
          $(this).stop().fadeTo(300,1);
          return false;
        });

        $(container).on('mouseleave', function(){
          $(container + ' a').stop().fadeTo(300,1);
          return false;
        });
    },
    links: function(container) {
      $(container + ' a').on('mouseenter', function(){
        $selector = $(container + ' a');
        $selector.stop().fadeTo(300,0.5);
        $(this).stop().fadeTo(300,1);
        return false;
      });

      $(container).on('mouseleave', function(){
        $(container + ' a').stop().fadeTo(300,1);
        return false;
      });
    }
  };



  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Vd = {
    // All pages
    'common': {
      init: function() {

        NavHover.mobile('.sidebar .primary-navigation');
        NavHover.links('.sidebar .archive');
        MobileNav.init();
        ToggleContent.init();

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Vd;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
